import { computed } from 'vue';
import { useStore } from './store';

/**
 * Composable for dark mode handling in widget
 * Provides dark mode state and helper function for conditional classes
 *
 * @returns {Object} Object containing dark mode properties and methods
 */
export const useDarkMode = () => {
  const store = useStore();

  const darkMode = computed(() => store.getters['appConfig/darkMode']);

  const prefersDarkMode = computed(() => {
    const isOSOnDarkMode =
      darkMode.value === 'auto' &&
      window.matchMedia('(prefers-color-scheme: dark)').matches;
    return isOSOnDarkMode || darkMode.value === 'dark';
  });

  /**
   * Helper function for conditional dark mode classes
   * @param {string} light - Class to apply in light mode
   * @param {string} dark - Class to apply in dark mode
   * @returns {string} The appropriate class(es) based on current mode
   */
  const $dm = (light, dark) => {
    if (darkMode.value === 'light') return light;
    if (darkMode.value === 'dark') return dark;
    return light + ' ' + dark;
  };

  return {
    darkMode,
    prefersDarkMode,
    $dm,
  };
};
